import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { filter } from '@ibk/shared-assets';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Chip } from '@ibk/shared-ui';
import { beneficiosTranslations } from '../../translations';
import styles from './BeneficiaryFilter.module.css';
import { BeneficiaryFilterModal } from './components/BeneficiaryFilterModal';
import { BeneficiarySearchInput } from './components/BeneficiarySearchInput';
import { FilterChip } from './components/FilterChip';
import { useBeneficiaryFilter } from './hooks/useBeneficiaryFilter';
const BeneficiaryFilterContent = React.forwardRef(({ onFilter, testIdIdentifier = 'BeneficiaryFilter', initialFilters, filterOptions, isLoadingFilters, trailingActions, filterVariant, }, ref) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appliedFilters, clearFiltersExceptName, setAppliedFilters, clearFilters } = useBeneficiaryFilter(onFilter);
    useEffect(() => {
        if (initialFilters && !appliedFilters) {
            setAppliedFilters(initialFilters);
        }
    }, [initialFilters, appliedFilters, setAppliedFilters]);
    useImperativeHandle(ref, () => ({
        clearFilters: () => {
            clearFilters();
        },
    }));
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleApplyFilters = (filters) => {
        setAppliedFilters(filters);
        handleCloseModal();
    };
    const handleClearFilters = () => {
        clearFiltersExceptName();
        handleCloseModal();
    };
    const handleRemoveFilter = () => {
        clearFiltersExceptName();
    };
    const handleSearchChange = (value) => {
        const currentFilters = appliedFilters || {
            contractType: [],
            cardStatus: [],
            jobRole: [],
            costCenter: [],
            department: [],
            category: [],
            employmentBond: [],
            branch: [],
            union: [],
        };
        const updatedFilters = {
            ...currentFilters,
            name: value || undefined,
        };
        setAppliedFilters(updatedFilters);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.filtersContainer, children: [_jsx("div", { className: styles.searchContainer, children: _jsx(BeneficiarySearchInput, { value: appliedFilters?.name, onChange: handleSearchChange, testIdIdentifier: testIdIdentifier }) }), _jsxs("div", { className: `${styles.filtersContent} ${trailingActions ? styles.filtersContentStart : ''}`.trim(), children: [_jsx(FilterChip, { appliedFilters: appliedFilters, onRemove: handleRemoveFilter, testIdIdentifier: testIdIdentifier }), _jsx(Chip, { text: t('filter'), size: 'small', "data-testid": `button${testIdIdentifier}Trigger`, onClick: handleOpenModal, leftImage: filter })] }), trailingActions && (_jsx("div", { className: styles.trailingActions, "data-testid": `view${testIdIdentifier}TrailingActions`, children: trailingActions }))] }), _jsx(BeneficiaryFilterModal, { show: isModalOpen, onClose: handleCloseModal, onClearFilters: handleClearFilters, onApplyFilters: handleApplyFilters, testIdIdentifier: testIdIdentifier, initialFilters: appliedFilters || undefined, filterOptionsOverride: filterOptions, isLoadingFiltersOverride: isLoadingFilters, filterVariant: filterVariant })] }));
});
BeneficiaryFilterContent.displayName = 'BeneficiaryFilterContent';
export const BeneficiaryFilter = React.forwardRef((props, ref) => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(BeneficiaryFilterContent, { ...props, ref: ref }) }));
});
BeneficiaryFilter.displayName = 'BeneficiaryFilter';
